import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Button, Avatar } from "@mui/material";
import classNames from "classnames";
import NavRoutes from "../routes/NavRoutes";
import { bgHandler } from "../helpers/styles.helper";
import { pageMenu } from "../routes/menu";
import aml from "../assets/imgs/works/Adeesha Logo Color.png";

const Navbar = () => {
  const [showMobileNavbar, setshowMobileNavbar] = useState(
    window.innerWidth <= 900
  );
  const [scrolling, setScrolling] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const container = document.getElementById("appContainer");
      if (container) {
        const containerRect = container.getBoundingClientRect();
        const scrollTop = container.scrollTop || window.pageYOffset;
        if (scrollTop > containerRect.top) {
          setScrolling(true);
        } else {
          setScrolling(false);
        }
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    function handleShowMobileNavbar() {
      if (window.innerWidth > 900) {
        setshowMobileNavbar(false);
      } else {
        setshowMobileNavbar(true);
      }
    }

    window.addEventListener("resize", handleShowMobileNavbar);
    return (_) => {
      window.removeEventListener("resize", handleShowMobileNavbar);
    };
  });

  return (
    <nav className={classNames("navbar", scrolling && "scrolled")}>
      <Link
        to={pageMenu.homePage.path}
        onClick={() => bgHandler(pageMenu.homePage.path)}
      >
        {showMobileNavbar ? (
          <Button color="white" className="navHeader">
            <Avatar
              alt="Adeesha Mahalekam Portfolio Web"
              src={aml}
              sx={{ width: 48, height: 48 }}
            />
          </Button>
        ) : (
          <Button color="white" className="navHeader">
            <Avatar
              alt="Adeesha Mahalekam Portfolio Web"
              src={aml}
              sx={{ width: 48, height: 48 }}
              className="mr-2"
            />
            Adeesha Mahalekam
          </Button>
        )}
      </Link>
      <NavRoutes showMobileNavbar />
    </nav>
  );
};

export default Navbar;
